import { DOCS_FORM_NAMES } from "core/consts";
import { ControlledTextarea } from "ds/ui";
import { FormFieldConfig } from "../..";

export const MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS = 100;

export const DischargeLetterCardiologyFormSections: FormFieldConfig<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY
>["sections"] = [
  {
    fields: {
      additional_diagnostic_findings: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .furtherDiagnosisLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="additional_diagnostic_findings"
            placeholder=" "
          />
        ),
        position: 10,
      },
      admission_medications: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .admissionMedicationLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="admission_medications"
            placeholder=" "
          />
        ),
        position: 11,
      },
      allergies: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .allergyLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="allergies"
            placeholder=" "
          />
        ),
        position: 5,
      },
      anamnesis: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .medicalHistoryLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="anamnesis"
            placeholder=" "
          />
        ),
        position: 3,
      },
      appointments: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .appointmentsLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="appointments"
            placeholder=" "
          />
        ),
        position: 14,
      },
      diagnoses: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .diagnosisLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="diagnoses"
            placeholder=" "
          />
        ),
        position: 1,
      },
      discharge_medications: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .dischargeMedicationsLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="discharge_medications"
            placeholder=" "
          />
        ),
        position: 12,
      },
      ecg: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology.ecgLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="ecg"
            placeholder=" "
          />
        ),
        position: 9,
      },
      findings: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .findingsLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="findings"
            placeholder=" "
          />
        ),
        position: 7,
      },
      lab_results: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .labResultsLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="lab_results"
            placeholder=" "
          />
        ),
        position: 8,
      },
      laboratory_parameters: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .parametersLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="laboratory_parameters"
            placeholder=" "
          />
        ),
        position: 15,
      },
      physical_status: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .physicalStatusLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="physical_status"
            placeholder=" "
          />
        ),
        position: 6,
      },
      recommendations: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .recommendationsLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="recommendations"
            placeholder=" "
          />
        ),
        position: 13,
      },
      social_history: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .socialHistoryLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="social_history"
            placeholder=" "
          />
        ),
        position: 4,
      },
      therapy_and_course: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formCardiology
                .therapyAndCourseLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="therapy_and_course"
            placeholder=" "
          />
        ),
        position: 2,
      },
    },
    position: 1,
    title: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formCardiology.sectionTitle,
  },
];
